<template>
  <v-dialog :value="dialog" max-width="500px"  @click:outside="closeDialog()">
    <v-card>
      <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
      <v-card-text>
        <div class="form align-self-center">
          <v-form v-on:submit.prevent="signIn()">
            <h2
                class="text-h5 font-weight-bold"
                :class="{'text-center': $vuetify.breakpoint.xs}"
            >
              Sign In to GUIOMENTOR
            </h2>
              <v-text-field
                  v-model="email"
                  :error-messages="emailErrors"
                  data-testid="v-text-field"
                  label="Email"
                  @input="emailOnChange()"
              />
              <v-text-field
                  v-model="password"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :error-messages="passwordErrors"
                  :type="showPassword ? 'text' : 'password'"
                  data-testid="v-text-field"
                  label="Password"
                  @click:append="showPassword = !showPassword"

              />
            <v-row class="my-0">
              <v-col class="d-flex flex-row justify-space-between mx-0 px-0 my-0">
                <v-checkbox
                    class="text-body-2 my-0 py-0 text-no-wrap"
                    dense
                    label="Remember me"
                    off-icon="mdi-checkbox-blank-circle-outline"
                    on-icon="mdi-check-circle-outline"
                />
                <a
                    class="text-decoration-none text-body-2 forgot-password text-no-wrap"
                    @click="closeDialog(true, '/forgot_password')"
                >Forgot password?
                </a>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="d-flex flex-row justify-space-between mx-0 my-0 px-0 py-0">
                <v-btn
                    :disabled="$v.$invalid || loading"
                    class="btn-text"
                    color="primary"
                    data-testid="login-btn"
                    type="submit"
                    width="46%"
                >
                  Log me in
                  <v-icon> mdi-arrow_right_alt</v-icon>
                </v-btn>
                <v-btn
                    class="btn-text"
                    color="primary"
                    data-testid="v-btn"
                    outlined
                    to="'/signup'"
                    @click="closeDialog(true, '/signup')"
                    width="46%"
                >
                  Sign up now
                  <v-icon> mdi-arrow_right_alt</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
          <v-row class="mt-3 mx-0 px-0">
          <v-col class="d-flex flex-column align-stretch mx-0 px-0" cols="12">
            <p class="subtitle-1">Save some time,</p>
            <GoogleSignInButton />
          </v-col>
        </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import google from "@/assets/google.png";
import {email, minLength, required} from "vuelidate/lib/validators";
import {mapMutations} from "vuex";
import {VUE_GOOGLE_CLIENT_ID} from "@/config/"
import GoogleSignInButton from "./GoogleSignInButton";

export default {
  components: {
    GoogleSignInButton
  },
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      google,
      email: "",
      password: "",
      showPassword: false,
      loading: false,
      params: {
        client_id: VUE_GOOGLE_CLIENT_ID
      },
    };
  },
  methods: {
    ...mapMutations({
      SET_AUTH_SUCCESS: "auth/SET_AUTH_SUCCESS",
      SET_USER_PROFILE: "auth/SET_USER_PROFILE",
      SET_LOADING: "loading/SET_LOADING",
      SET_AUTH_DIALOG: "auth/SET_AUTH_DIALOG"
    }),
    closeDialog(route = false, to = '') {
      this.email = ''
      this.password = ''
      this.SET_AUTH_DIALOG(false)
      if(route) this.$router.push(to);
    },
    emailOnChange() {
      this.$v.email.$touch();
      this.emailTaken = false;
    },

    async signIn() {
      try {
        this.loading = true;
        const body = {email: this.email, password: this.password};
        const {data} = await this.axios.post('users/login/', body, data);

        const user = data.data
        this.SET_AUTH_SUCCESS(user);
        this.SET_USER_PROFILE(user.profile);
        this.closeDialog()
        localStorage.setItem("access_token", user.tokens.access);
        localStorage.setItem("refresh_token", user.tokens.refresh);

      } catch (error) {
        this.$snackbar.showMessage({
          content: this.constructSignInErrorMessage(error) || this.$t('errors.somethingWentWrongError'),
          color: "error",
        });
      } finally {
        this.loading = false;
      }
    },

    constructSignInErrorMessage(error) {
      // for the google auth popup errors
      if (error.error) return error.error.replace(/_/g, ' ')

      let errorMessage = '';
      const errorData = error.response?.data || ''
      if (errorData) {
        if (errorData.detail) {
          errorMessage = errorData.detail
        } else if (errorData.data?.non_field_errors) {
          const errors = errorData.data.non_field_errors
          if (errors.length === 1) return errorMessage = errors[0]
          errors.forEach((msg, index) => {
            if (index === errors.length - 1) {
              errorMessage += msg
            }
            errorMessage += msg + ', '
          })
        }
      }
      return errorMessage
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
      errors.push(this.$t("auth.forms.errors.emailMustBeValid"));
      !this.$v.email.required &&
      errors.push(this.$t("auth.forms.errors.emailRequired"));
      this.emailTaken &&
      errors.push(this.$t("errors.emailTaken", {email: this.email}));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
      errors.push(this.$t("auth.forms.errors.passwordRequired"));
      !this.$v.password.min &&
      errors.push(this.$t("auth.forms.errors.passwordLength"));
      return errors;
    }
  },
  validations: {
    email: {
      required, email
    },
    password: {
      required, min: minLength(6)
    },
  }
}
;
</script>

<style lang="scss" scoped>
.form {
  padding: 35px;

  .forgot-password {
    color: rgba(0, 0, 0, 0.6);
  }

  .v-btn {
    text-transform: none !important;
  }

  .login-google {
    background: #f5f6f8 !important;
    color: rgba(66, 66, 66, 0.6) !important;
    border-radius: .3em;
  }


  .social-img {
    width: 20px;
    height: 80%;
  }
}
</style>
